import React from 'react';

import { Flex, mediaQueries, Shimmer } from '@zeal/web-ui';
import { useMediaQuery } from '@zeal/zeal-lib';

const LoginSkeleton = () => {
	const isDesktop = useMediaQuery(mediaQueries.min.md);

	return (
		<Flex isColumn gap="6" align="center" className="h-full">
			<Flex
				gap="6"
				isColumn
				justify={isDesktop ? 'center' : 'start'}
				className="h-full px-4 py-6 md:py-12 md:px-7"
				style={{
					width: isDesktop ? '500px' : '343px',
				}}
			>
				<Flex gap="2" isColumn>
					<Shimmer width="full" height="10" rounded="none" />
					<Shimmer width="full" height="8" rounded="none" />
				</Flex>
				<Flex gap="6" isColumn>
					<Flex gap="6" isColumn>
						<Shimmer width="full" height="20" rounded="none" />
						<Shimmer width="full" height="20" rounded="none" />
					</Flex>
					<Flex align="center" justify="between">
						<Shimmer width="32" height="6" rounded="none" />
						<Shimmer width="28" height="5" rounded="none" />
					</Flex>
					<Shimmer width="full" height="12" rounded="none" />
				</Flex>
			</Flex>
		</Flex>
	);
};

export default LoginSkeleton;
